import styled from 'styled-components';

export const LinkWrapper = styled.div`
  display: flex;
  align-self: flex-end;
  margin-top: 10px;
`;

export const ButtonGroupWrapper = styled.div`
  margin-bottom: 20px;
`;
